import { useTenant } from "@/providers/session";
import { useEffect, useState } from "react";

type GlobalFilter = {
  id: string;
  value: any;
};

const useGlobalFilters = (tableName: string) => {
  const [globalFilter, setFilter] = useState<string>("");
  const { tenantId } = useTenant();

  useEffect(() => {
    if (!tenantId) return;
    const storedFilter = sessionStorage.getItem(
      `${tenantId}_${tableName}_globalFilters`,
    );
    if (storedFilter != null && storedFilter !== "undefined") {
      setFilter(JSON.parse(storedFilter));
    } else {
      setFilter("");
    }
  }, [tenantId, tableName]);

  const updateFilter = (newFilter: GlobalFilter[]) => {
    if (!tenantId) return;

    sessionStorage.setItem(
      `${tenantId}_${tableName}_globalFilters`,
      JSON.stringify(newFilter ?? []),
    );
  };
  const onGlobalFilterChange = (filterState: any) => {
    setFilter(filterState);
    updateFilter(filterState);
  };

  return { globalFilter, onGlobalFilterChange };
};

export default useGlobalFilters;
